module.exports = __webpack_public_path__ + "media/images/III@2x-b5f8594d49c6a0f2422e1c7faec1229a.png";